module.exports = __webpack_public_path__ + "img/title.43d18476.png";